import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { ThemeProvider } from "./components/ThemeContext";
import ConfigProvider from "./utils/Config.jsx";
import ApiProvider from "./utils/ApiContext.jsx";
import AppContext from "./utils/Context";
import LoginPage from "./Page/Login.jsx";
import HomeContent from "./Page/Home.jsx";
import CallbackADPage from "./Page/CallbackAD.jsx";


function App() {
  return (
    <ThemeProvider>
      <ConfigProvider>
        <ApiProvider>
          <AppContext>
            <BrowserRouter>
              <Routes>
                <Route path="/" element={<Navigate to="/chat" replace />} />
                <Route path="/login" element={<LoginPage />} />
                <Route path="/chat" element={<HomeContent />} />
                <Route path="/callback-ad" element={<CallbackADPage />} />
              </Routes>
            </BrowserRouter>
          </AppContext>
        </ApiProvider>
      </ConfigProvider>
    </ThemeProvider>
  );
}

export default App;